import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../../../../packages/kiti/components/structure/Grid'
import Text, { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import LineSeparator from '../../../../../../../packages/kiti/components/helpers/LineSeparator'

const ModalHeader = ({ hasMoreThanOneTrigger, isCategory }) => {
  const { t } = useTranslation('editChecklist')
  const removingType = isCategory ? t('categoryLabel') : t('questionLabel')
  const title = hasMoreThanOneTrigger
    ? t('removeModal.multipleAutomationsAffected', { removingType })
    : t('removeModal.singleAutomationAffected', { removingType })

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={10}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
      </Grid>
      <Text inline>{t('removeModal.confirmContinue')}</Text>
      <LineSeparator weight={4} />
    </>
  )
}

export default ModalHeader
